<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal" v-esc="escape">
    <div class="w-full" @keyup.enter="submitData">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "Yeni Boy" : "Boy Düzenle" }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
        <form data-vv-scope="form-1">
          <div class="px-6 pt-6">
            <vs-input id="Size" name="Boy" v-validate="'required|min:2|max:40'" v-model="newProductSize.name"
              class="w-full" label-placeholder="Boy İsmi" />
            <span class="text-danger text-sm" v-show="errors.has('form-1.Boy')">{{ errors.first('form-1.Boy') }}</span>
          </div>
        </form>
        <div class="flex mt-5 px-6 pb-4">
          <vs-button class="mr-auto" type="gradient" color="danger" @click="isSidebarActiveLocal = false">
            Vazgeç
          </vs-button>
          <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {
    createProductSize,
    updateProductSize
  } from '@/api/ProductSize';
  export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {},
      }
    },
    data() {
      return {
        newProductSize: {},
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar')
            this.$validator.reset()
            this.initValues()
          }
        }
      }
    },
    methods: {
      escape() {
        if (this.isSidebarActiveLocal == true) this.isSidebarActiveLocal = false;
      },
      initValues: function () {
        this.newProductSize = {};
      },
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll('form-1');
        if (checker) {
          if (this.newProductSize.id) {
            updateProductSize(this.newProductSize).then(res => {
              if (res && res.status === 200) {
                this.$vs.notify({
                  color: 'success',
                  title: 'Başarılı !',
                  text: 'Boy Güncelleme İşlemi Başarılı !'
                });
                this.$emit('saveChanges', res.data);
                this.initValues();
                this.$validator.reset();
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Boy Güncelleme İşlemi Başarısız !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası !'
              });
            });
          } else {
            this.newProductSize.id = 0;
            createProductSize(this.newProductSize).then(res => {
              if (res && res.status === 200) {
                this.$vs.notify({
                  color: 'success',
                  title: 'Başarılı !',
                  text: 'Boy Ekleme İşlemi Başarılı !'
                });
                this.$emit('saveChanges', res.data);
                this.initValues();
                this.$validator.reset();
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Boy Ekleme İşlemi Başarısız ! '
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası ! '
              });
            });
          }
        }
      },
    },
    components: {
      VuePerfectScrollbar
    },
    watch: {
      isSidebarActive: function (val) {
        if (!val) return;
        if (Object.entries(this.data).length === 0) {
          this.initValues();
          this.$validator.reset();
        } else {
          this.newProductSize = _.cloneDeep(this.data);
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .style-chooser .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: red;
    text-transform: lowercase;
    font-variant: small-caps;
  }

  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .tabPager {
    background-color: darkgreen;
    border-radius: 50%;
  }

</style>
